module.exports = __webpack_public_path__ + "images/help/video-docs@2x-de2347721c66f900983e647b8bc10ea4.png";